export const assetsHandlers = []
